const changeLog = [
  {"version": "02.13.03", "issues": [
    {"id": "", "description": "Changed hash algorithm"},
  ]},
  {"version": "02.13.02", "issues": [
    {"id": "", "description": "Fixed issues with command line build script - needed to update internal libraries"},
    {"id": "", "description": "Added Auto-refresh toggle to make it easier to view logs without refresh blocking the dialog value."}
  ]},
  {"version": "02.12.02", "issues": [
    {"id": "", "description": "Modified repost to set the RobotEditOnly flag to true, which triggers a robot multi-pallet edit ONLY. No import OR reprinting of tags."}
  ]},
      {"version": "02.12.01", "issues": [
        {"id": "MRA-563", "description": "Now allows user to send a test receipt print."},
        {"id": "MRA-562", "description": "Now allows user to send request a receipt repost."},
      ]},
      {"version": "02.10.01", "issues": [
          {"id": "MRA-531", "description": "Fixed autogrid refresh causes logs/detail to fly away."}
        ]},
        {"version": "02.08.01", "issues": [
          {"id": "MRA-526", "description": "Record Grower Nbr in Receipt to pass to Observations MRA Lookup."} 
        ]}
    ]

export default changeLog
